import React from "react";
import ImageGallery from "../components/ImageGallery";
import Footer from "../components/footer";

export default () => (
  <div>
    <section
      className="jumbotron breadcumb h-vh"
      style={{ backgroundImage: `url(${"./img/witaly_grpup_header.jpg"})` }}
    >
      <div className="homebread">
        <div className="container-fluid">
          <div className="row m-10-hor">
            <div className="col-md-10 mx-auto text-center ">
              <div className="heading">Welcome to Witaly Group</div>
              <div className="content mx-auto">
                We are a conglomerate of 4 companies operating within Italy,
                Middle East, and East Africa. We are focused in 4 industries:
                Interior Design, Shipping, Hospitality, Waste Management and
                Sustainability.
              </div>
              <div class="btn" onClick={() => window.open("/home2", "_self")}>
                <span className="shine"></span>
                <span>Contact Us</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="container-fluid pb-0 black_more">
      <div className="row m-10-hor">
        <div className="col-md-5">
          <div className="heading">
            Witaly <span className="br"></span>Interior
          </div>
          <div className="subheading">Precision in Every Detail</div>
        </div>

        <div className="col-md-7">
          <div className="content">
            Witaly is an interior design brand dedicated to the philosophy that
            true luxury is found in the perfect balance of form and function. By
            merging modern architectural principles with an unwavering eye for
            detail, Witaly transforms living spaces into serene, high-end
            retreats.
          </div>
          <div className="content">
            Our approach centers on "Experience Design With Precision," a
            commitment to creating environments that are as technically lawless
            as they are aesthetically breathtaking. From the initial concept to
            the final touch, every element is curated to reflect a lifestyle of
            sophistication and modern elegance..
          </div>
        </div>
      </div>
    </section>

    <section className="container-fluid black_more">
      <div className="row m-10-hor">
        <div className="col-12">
          <div className="AppContainer">
            <ImageGallery />
          </div>
        </div>
      </div>
    </section>

    <section className="container-fluid p-0">
      <div className="row">
        <div className="col-md-4 p-0">
          <div className="features">
            <div className="bg">
              <img src="./img/bg-serv-1.jpg" alt="bg-features" />
            </div>
            <div className="content">
              <div className="heading">Concept Design</div>
              <div className="con-text">
                Qui ut ceteros comprehensam. Cu eos sale sanctus eligendi, id
                ius elitr saperet,ocurreret pertinacia pri an. No mei nibh
                consectetuer
              </div>
              {/* <div className="link">
                <span className="shine"></span>
                Read More
              </div> */}
            </div>
          </div>
        </div>

        <div className="col-md-4 p-0">
          <div className="features">
            <div className="bg">
              <img src="./img/bg-serv-2.jpg" alt="bg-features" />
            </div>
            <div className="content">
              <div className="heading">Interior</div>
              <div className="con-text">
                Qui ut ceteros comprehensam. Cu eos sale sanctus eligendi, id
                ius elitr saperet,ocurreret pertinacia pri an. No mei nibh
                consectetuer
              </div>
              <div className="link">
                <span className="shine"></span>
                Read More
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4 p-0">
          <div className="features">
            <div className="bg">
              <img src="./img/bg-serv-3.jpg" alt="bg-features" />
            </div>
            <div className="content">
              <div className="heading">Architecture</div>
              <div className="con-text">
                Qui ut ceteros comprehensam. Cu eos sale sanctus eligendi, id
                ius elitr saperet,ocurreret pertinacia pri an. No mei nibh
                consectetuer
              </div>
              <div className="link">
                <span className="shine"></span>
                Read More
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
);
